
























import Vue from 'vue';

export default Vue.extend({
  name: 'BottomFooter',
  data() {
    return {
      currentYear: new Date().getFullYear(), // 获取当前年
    };
  },
});
